import TextModal from '../../components/molecules/modals/text-modal.vue'
export default {
  components: { TextModal },
  data() {
    return {
      isModalActive: false,
      modalText: {
        title: '確認',
        caption:
          'ギフトコードが適用されていませんがこのまま離れてよろしいですか？適用する場合はキャンセルして「適用する」ボタンを押してください。',
        primaryButton: 'このまま離れる',
        cancelButton: 'キャンセル'
      }
    }
  },
  methods: {
    showModal() {
      this.isModalActive = true
    },
    closeModal() {
      this.isModalActive = false
    },
    onClickUnlinkLogo(url) {
      const giftCodeForm = document.querySelector(
        '#gift_code_serial_form_gift_code'
      )
      if (giftCodeForm && giftCodeForm.value) {
        this.showModal()
        return
      }
      this.moveToUrl(url)
    },
    onClickPrimaryButton(url) {
      this.moveToUrl(url)
    },
    moveToUrl(url) {
      location.href = url
      this.closeModal()
    }
  }
}
